export enum SortMode {
  unknown = 'unknown',
  region = 'regio',
  center = 'centrum',
  missedConnection = 'missed_connection',
}
